import { render, staticRenderFns } from "./PushClient.vue?vue&type=template&id=48f820c6&scoped=true"
import script from "./PushClient.vue?vue&type=script&lang=js"
export * from "./PushClient.vue?vue&type=script&lang=js"
import style0 from "./PushClient.vue?vue&type=style&index=0&id=48f820c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f820c6",
  null
  
)

export default component.exports